import type { CSSProperties } from 'react';

export const BRAND_COLORS: Record<string, string> = {
  huttopia: '#00533C',
  onlycamp: '#82B624',
  bivouac: '#D7AB1C',
  citykamp: '#B74933',
};

export const BRAND_LABELS: Record<string, string> = {
  huttopia: 'Camping Huttopia',
  onlycamp: 'Camping Onlycamp',
  bivouac: 'Bivouac Huttopia',
  citykamp: 'Camping Citykamp',
};

export const getBrandColor = (brand?: string | null): string | undefined =>
  BRAND_COLORS[brand?.toLowerCase() ?? ''];

export const getBrandLabel = (brand?: string | null): string | undefined =>
  BRAND_LABELS[brand?.toLowerCase() ?? ''];

export const getBrandTextColor = (brand?: string | null): string =>
  brand?.toLowerCase() === 'bivouac' ? BRAND_COLORS.huttopia : '#ffffff';

export const getBrandBadgeStyle = (brand?: string | null): CSSProperties | undefined => {
  const backgroundColor = getBrandColor(brand);
  if (!backgroundColor) return undefined;
  return { backgroundColor, color: getBrandTextColor(brand), border: 'none' };
};
